var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create_question_wrap" }, [
    _c("div", { staticClass: "create_question_title" }, [
      _c("h2", [_vm._v("创建实操题")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.saveQuestion("next", "ruleForm")
                }
              }
            },
            [_vm._v("保存并继续")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.saveQuestion("back", "ruleForm")
                }
              }
            },
            [_vm._v("保存并返回")]
          ),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.closeCreateQuestion } }, [
            _vm._v("返回")
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "create_question_main",
        style: "height:" + (_vm.windowHeight - 65) + "px"
      },
      [
        _c(
          "div",
          { staticClass: "questions_info" },
          [
            _c(
              "el-form",
              {
                ref: "ruleForm",
                attrs: {
                  model: _vm.ruleForm,
                  rules: _vm.rules,
                  "label-width": "100px"
                }
              },
              [
                _vm.isShowResourceClassify
                  ? _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          label: "资源分类：",
                          prop: "resourceCategoryId"
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "resource_classify",
                            attrs: { placeholder: "请选择资源分类" },
                            model: {
                              value: _vm.ruleForm.resourceCategoryId,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.ruleForm,
                                  "resourceCategoryId",
                                  $$v
                                )
                              },
                              expression: "ruleForm.resourceCategoryId"
                            }
                          },
                          _vm._l(_vm.resourceDatas, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.categoryName,
                                value: item.id
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "25%" },
                    attrs: { label: "科目：", prop: "subjectValue" }
                  },
                  [_c("p", [_vm._v(_vm._s(_vm.subjectName))])]
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "30%" },
                    attrs: { label: "难度：", prop: "difficulty" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择难度" },
                        model: {
                          value: _vm.ruleForm.difficultyValue,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "difficultyValue", $$v)
                          },
                          expression: "ruleForm.difficultyValue"
                        }
                      },
                      _vm._l(_vm.difficultyOptions, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.label, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "40%" },
                    attrs: { label: "建议分数：", prop: "gradeValue" }
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.ruleForm.gradeValue,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "gradeValue", $$v)
                        },
                        expression: "ruleForm.gradeValue"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "25%" },
                    attrs: { label: "用途：", prop: "labelId" }
                  },
                  [_c("p", [_vm._v(_vm._s(_vm.labelName))])]
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "30%" },
                    attrs: { label: "公司：", prop: "companyId" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择公司", clearable: "" },
                        model: {
                          value: _vm.ruleForm.companyId,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "companyId", $$v)
                          },
                          expression: "ruleForm.companyId"
                        }
                      },
                      _vm._l(_vm.companyDatas, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "questionTitlt",
                    staticStyle: { width: "40%" },
                    attrs: { label: "试题标题：", prop: "questionTitle" }
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "20", placeholder: "请输入试题标题" },
                      model: {
                        value: _vm.ruleForm.questionTitle,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "questionTitle", $$v)
                        },
                        expression: "ruleForm.questionTitle"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "knowledgePoint",
                    staticStyle: { width: "100%" },
                    attrs: { label: "知识点：", prop: "knowledgePoints" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { multiple: "", placeholder: "请选择知识点" },
                        model: {
                          value: _vm.ruleForm.knowledgePoints,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "knowledgePoints", $$v)
                          },
                          expression: "ruleForm.knowledgePoints"
                        }
                      },
                      [
                        _vm.knowledgePointsList.length > 0
                          ? _c(
                              "div",
                              _vm._l(_vm.knowledgePointsList, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                })
                              }),
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "labelWrap",
                    staticStyle: { width: "100%" },
                    attrs: { label: "标签：", prop: "label" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          placeholder: "请选择标签",
                          filterable: ""
                        },
                        model: {
                          value: _vm.ruleForm.label,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "label", $$v)
                          },
                          expression: "ruleForm.label"
                        }
                      },
                      [
                        _vm.labelList.length > 0
                          ? _c(
                              "div",
                              _vm._l(_vm.labelList, function(item) {
                                return _c(
                                  "el-option",
                                  {
                                    key: item.id,
                                    staticClass: "label_option",
                                    attrs: {
                                      label: item.labelName,
                                      value: item.id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.labelName) +
                                        "\n                "
                                    ),
                                    _c("i", {
                                      staticClass: "el-icon-error delete_label",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.deleteLabel(item)
                                        }
                                      }
                                    })
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "customLabel" },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入自定义标签",
                            maxlength: "20"
                          },
                          model: {
                            value: _vm.ruleForm.customLabel,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.ruleForm,
                                "customLabel",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "ruleForm.customLabel"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-button", { on: { click: _vm.createLabel } }, [
                          _vm._v("＋")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "questionsTypes-tabs" },
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.ruleForm.addTestTypeId,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "addTestTypeId", $$v)
                  },
                  expression: "ruleForm.addTestTypeId"
                }
              },
              _vm._l(_vm.ruleForm.addTestTypeOptions, function(item, index) {
                return _c("el-tab-pane", {
                  key: index,
                  attrs: {
                    label: item.questiontypeName,
                    name: item.id.toString()
                  }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "question-types-area" },
          [
            _c(_vm.comp, {
              ref: "GroupComp",
              tag: "component",
              attrs: { isUploading: _vm.isUploading },
              on: { changeUploadStatus: _vm.changeUploadStatus },
              model: {
                value: _vm.compValue,
                callback: function($$v) {
                  _vm.compValue = $$v
                },
                expression: "compValue"
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d083c90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d083c90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/course/components/createQuestion.vue
// module id = null
// module chunks = 